<template>
  <div class="mr-2">
    <v-btn
      v-if="allowSendTest"
      small
      class="mr-1 my-1"
      data-track="marketing.eblast-send-test.open"
      @click="$emit('sendEblastTest')"
    >
      Send Test Email
    </v-btn>
    <v-btn
      v-if="allowSend"
      :disabled="sourceType === 'pressrelease' && pressReleaseStatus !== 'approved'"
      small
      color="primary"
      data-track="marketing.eblast-send.open"
      @click="$emit('sendEblastCampaign')"
    >
      Send Campaign
    </v-btn>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  name: 'MarketingTopPanelSendButtons',

  props: {
    sourceType: {
      type: String,
      default: '',
    },
    pressReleaseStatus: {
      type: String,
      default: '',
    },
    allowSend: Boolean,
    allowSendTest: Boolean
  }
})
</script>
